import React from 'react'
import usePage from '../../../hooks/usePage'

const NotFound = () => {
  usePage('Page Notfound')
  return (
    <h1>
      NotFound
    </h1>
  )
}

export default NotFound
